import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const styles = xcss({
	display: 'inline-block',
	font: 'font.body',
	color: 'color.text.subtle',
	textDecoration: 'none',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});

const SearchMetadataGeneric = ({ label }: { label: string }): React.JSX.Element => {
	return <Box xcss={styles}>{label}</Box>;
};

export default SearchMetadataGeneric;
